import firebase from "firebase"
import "firebase/storage"

const firebaseConfig = {
    apiKey: "AIzaSyBa6Mmj5D9XjTTc_a-zrn6EsDTc9brCUyA",
    authDomain: "storageimage-2db0b.firebaseapp.com",
    projectId: "storageimage-2db0b",
    storageBucket: "storageimage-2db0b.appspot.com",
    messagingSenderId: "72633594640",
    appId: "1:72633594640:web:36c361b7768c9cb449ab95"
  };


const Database = firebase.initializeApp(firebaseConfig);

const storage = firebase.storage();

export{storage,Database}


